module.exports = __webpack_public_path__ + "static/media/4ofakind.09d4f6dd.png";